<template>
  <div class="admin-datatable">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Zawodnicy</v-toolbar-title>
    </v-toolbar>
    </v-card>
    <v-card class="mt-2 pb-1">
      <v-card-title>
        <v-form class="flex">
            <v-layout row wrap justify-start>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-text-field v-model="context.searchQuery"
                  clearable
                  label="Szukaj"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 class="pa-1">
                <v-select
                  v-model="context.package"
                  :items="allPackagesOptions"
                  label="Pakiet"
                  clearable
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 lg3 class="pa-1">
                <v-checkbox
                  label="Bez treningu w tym miesiącu"
                  v-model="context.monthWithoutTraining">
                </v-checkbox>
              </v-flex>
              <v-flex xs12 sm6 lg3 class="pa-1">
                <v-checkbox
                  label="Bez treningu w następnym miesiącu"
                  v-model="context.nextMonthWithoutTraining">
                </v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="runners"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
      >
        <template slot="items" slot-scope="props">
          <tr>
          <td>
            <router-link :to="{ name: 'runner-plan', params: { id: props.item.id }}">
              {{props.item.first_name}} {{props.item.last_name}}
            </router-link>
          </td>
          <td>{{ props.item.package_name}}</td>
          <td>{{ formatterBool(props.item.get_tshirt)}}</td>
          <td>{{ formatterBool(props.item.get_card)}}</td>
          <td>{{ props.item.last_training | formatDate('LL') || 'Brak'}}</td>
          <td class="actions">
            <rp-icon
              type="edit"
              tooltip="edytuj"
              class="mr-2"
              @click="props.expanded = !props.expanded"
            />
          </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
            <runner-trainer-update-form :runner-data="props.item" @success="props.expanded = false; refresh()"></runner-trainer-update-form>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {fetchTrainerRunners} from './api'
import {ListMixin} from '@/utils/ListMixin'
import {boolFormatter} from '@/utils/formatters'
import * as types from '@/store/mutation-types'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import RunnerTrainerUpdateForm from './RunnerTrainerUpdateForm'

export default {
  name: 'runners',
  components: {RunnerTrainerUpdateForm},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      runners: [],
      headers: [
        {
          value: 'last_name',
          text: 'imię i nazwisko',
          sortable: true
        },
        {
          value: 'package',
          text: 'pakiet',
          sortable: true
        },
        {
          value: 'get_tshirt',
          text: 'koszulka',
          sortable: true
        },
        {
          value: 'get_card',
          text: 'karta',
          sortable: true
        },
        {
          value: 'last_training',
          text: 'ostatni wpisany trening',
          sortable: true
        },
        {
          value: 'actions',
          text: 'akcje',
          align: 'center',
          sortable: false,
          width: '180px'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['allPackagesOptions'])
  },
  created () {
    this.$store.dispatch(types.ALL_PACKAGES_REQUEST)
  },
  watch: {
    context: {
      handler () {
        this.getRunners()
      },
      deep: true
    },
    '$route': 'getRunners'
  },
  methods: {
    formatterBool (data) {
      return boolFormatter(data)
    },
    getRunners (ctx) {
      this.loading = true
      let params = this.prepareParams()
      if (this.context.package !== null) {
        params['package'] = this.context.package
      }
      if (this.context.monthWithoutTraining === true) {
        params['month_without_training'] = this.context.monthWithoutTraining
      }
      if (this.context.nextMonthWithoutTraining === true) {
        params['next_month_without_training'] = this.context.nextMonthWithoutTraining
      }
      let promise = fetchTrainerRunners(this.$route.params.id, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.runners = data
        return data
      })
    },
    refresh: _.debounce(function () {
      this.getRunners()
    }, 400)
  }
}
</script>



// WEBPACK FOOTER //
// src/runners/TrainerRunners.vue